// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5VmUl","left":"styles_left__1Z-jn"};